import { useMemo } from "react";

/**
 * HTML文字列を解析し、h1 ~ h4要素に動的にIDを付与する関数
 * @param {string} html - 処理するHTML文字列
 * @returns {string} IDが付与されたHTML文字列
 */
const addIdsToHeadings = (html: string): string => {
  const parser = new DOMParser();
  const doc = parser.parseFromString(html, "text/html");
  const headings = doc.querySelectorAll("h1, h2, h3, h4");

  headings.forEach((heading, index) => {
    heading.id = heading.textContent?.trim() || heading.id || `header-${index}`;
  });

  return doc.body.innerHTML;
};

/**
 * CosmicJSのRichTextレンダリング用コンポーネント。
 *
 * @component
 * @param {Object} props - コンポーネントのプロパティ
 * @param {string} props.html - レンダリングするHTML文字列
 * @returns {JSX.Element} レンダリングされたRichTextコンテンツ
 */
export const useRichTextRenderWithIds = ({
  html,
  enabledPageLink,
}: {
  html: string;
  enabledPageLink?: boolean;
}) => {
  const processedHtml = useMemo(() => {
    if (!enabledPageLink) return html;
    return addIdsToHeadings(html);
  }, [enabledPageLink, html]);

  return processedHtml;
};
